import m from 'mithril';
import {trans, has_permission} from "../helpers";

import SelectTypeahead from '../selectTypeaheadComponent.js';

let challenge_state = require('../new_challenge_creator/challengeState.js');



function get_groups() {
    m.request('/api/groups?part=items').then(d => {
        challenge_state.groups = d;

        challenge_state.groups.forEach(g => {
            if (!(g.code in challenge_state.new_exercise.groups)) {
                challenge_state.new_exercise.groups[g.code] = {
                    id_group: g.id_group*1,
                    list: []
                };
            }
        });
    }).catch(err => {
        alert('Something went wrong, please refresh page.')
    })
}

class GroupsSelector {
    view() {
        return m('.groups-selector', [
            challenge_state.groups.map(g => {
                return [
                    m('label', g.title),
                    challenge_state.new_exercise.groups[g.code] &&
                    m(SelectTypeahead, {
                        listMode: true,
                        list: g.items,
                        selectedItems: challenge_state.new_exercise.groups[g.code], // must be object with 'list' atribute (see function: get_groups())
                        // placeholder: trans('challenge.select_group_placeholder'),
                        placeholder: trans('common.all_age_groups'),
                        dimPlaceholder: false,
                        noResultsText: trans('common.no_results'),
                        getItemText: i => i.title,
                        getItemId: i => i.id_group_item
                    })
                ]
            })
        ]);
    }
}

class SportsSelector {
    getSportsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&limit=40&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    getSportTitle(sport) {
        // return Array((sport.depth*5)+1).join(`\u00A0`) + sport.title;
        return sport.title;
    }

    view() {
        return [
            m('label', trans('exercises.form.sports')),
            // challenge_state.new_exercise.groups[g.code] &&
            m(SelectTypeahead, {
                listMode: false,
                getData: this.getSportsData,
                selectedItems: challenge_state.new_exercise.sports, // must be object with 'list' atribute (see function: get_groups())
                placeholder: trans('common.all_sports'),
                dimPlaceholder: false,
                noResultsText: trans('common.no_results'),
                getItemText: this.getSportTitle,
                getItemId: s => s.id_sport
            })
        ]
    }
}

class CreateExercise{
    oninit() {
        // challenge_state.new_exercise = challenge_state.get_empty_exercise();
        get_groups();
    }

    get_exercise_types() {
        let url = '/api/exercises_types'
        
        m.request(url)
            .then(d => {
                challenge_state.exercise_types = d.feed;
            }).catch(err => {
            alert('Something went wrong, please refresh page.')
        });
    }

    validate_exercise() {        
        let problems = challenge_state.validate_form(challenge_state.exercise_validation, challenge_state.new_exercise);

        let problems_num = Object.keys(problems).length;

        if (problems_num > 0) {
            let alert_msg = trans('challenge.validation.cannot_continue')+":\n";

            for (var key in problems) {
                if (!problems.hasOwnProperty(key)) continue;

                let problem = problems[key];

                let problem_msg = "";

                let p_key = problem.split(":")[0];

                if (p_key == "required") {
                    problem_msg = trans('challenge.validation.is_required');
                }

                if (p_key == "min") {
                    let p_v = problem.split(":")[1];
                    problem_msg = trans('challenge.validation.should_be_at_least') + " " + p_v + " " + trans('challenge.validation.characters_long');
                }

                if (p_key == "max") {
                    let p_v = problem.split(":")[1];
                    problem_msg = trans('challenge.validation.should_be_less_then') + " " + p_v + " " + trans('challenge.validation.characters_long');
                }

                alert_msg += "- " + trans('exercises.form.' + key) + " "  + problem_msg + "\n"; 
            }

            alert(alert_msg);
        }

        return problems_num == 0;
    }

    save_exercise() {
        let valid = this.validate_exercise();

        if (!valid)
            return;

        // makes deep copy
        let exercise = JSON.parse(JSON.stringify(challenge_state.new_exercise));


        let group_items = [];

        Object.keys(exercise.groups).map(group_code => {
            let group = exercise.groups[group_code];
            group.list.map(item => {
                group_items.push(item.id_group_item*1);
            });
        });

        exercise.group_items = group_items;
        delete exercise['groups'];

        let sports = exercise.sports.list.map(sc => sc.id_sport*1);
        exercise['sports'] = sports;

        challenge_state.exercise_loading = true;
        m.redraw();

        if (challenge_state.mode == 'update_exercise') {
            this.update_exercise(exercise);
        } else {
            this.insert_exercise(exercise);
        }
    }

    insert_exercise(exercise) {
        m.request({
            method: "POST",
            url: "/api/exercises",
            responseType: "json",
            body: exercise
        }).then(d => {
            challenge_state.new_exercise.id_exercise = d.data;
            
            challenge_state.exercise_loading = false;
            challenge_state.current_step = 'edit_exercise_content';
        }).catch(e => {
            console.log(e)
            alert('Problem saving. try again')
        })
    }

    update_exercise(exercise) {
        m.request({
            method: "POST",
            url: "/api/exercises/" + challenge_state.new_exercise.id_exercise,
            responseType: "json",
            body: exercise
        }).then(d => {            
            challenge_state.exercise_loading = false;
            challenge_state.current_step = 'edit_exercise_content';
        }).catch(e => {
            console.log(e)
            alert('Problem saving. try again')
        })
    }

    go_back(e) {
        challenge_state.current_step = 'select_exercises';
    }

    get_visibility() {
        if (challenge_state.new_exercise.public)
            return 0;

        if (!challenge_state.new_exercise.public && !challenge_state.new_exercise.unlisted)
            return 1;

         if (!challenge_state.new_exercise.public && challenge_state.new_exercise.unlisted)
            return 2;
    }

    set_visibility(visibility) {
        if (visibility == 0) {
            challenge_state.new_exercise.public = 1;
            challenge_state.new_exercise.unlisted = 0;
        }
        if (visibility == 1) {
            challenge_state.new_exercise.public = 0;
            challenge_state.new_exercise.unlisted = 0;
        }
        if (visibility == 2) {
            challenge_state.new_exercise.public = 0;
            challenge_state.new_exercise.unlisted = 1;
        }
    }

    view(){
        return [
            (challenge_state.mode == 'insert' || challenge_state.mode == 'update') && // ONLY THROUGH CHALLENGE EDITOR
            m('.create-exercise-header', [
                m('h2.editor-title', trans('challenge.creating_exercise_title')),

                m('.link', {
                    onclick: e => this.go_back(e)
                }, trans('challenge.go_back_btn')),
            ]),

            m('.ijf-form', [
                m('.line', [
                    m('.line-element', [
                        m('label', [
                            trans('exercises.form.title'),
                            m('span.required-asterisk', '*')
                        ]),
                        m('input', {
                            name: 'title',
                            id: 'title',
                            type: 'text',
                            value: challenge_state.new_exercise.title, 
                            onchange: _dom => {
                                challenge_state.new_exercise.title = _dom.target.value
                            }
                        })
                    ])
                ]),

                m('.line', [
                    m('.line-element', [
                        m('label', [
                            trans('exercises.form.short_description'),
                        ]),
                        m('input', {
                            name: 'short_description',
                            id: 'short_description',
                            type: 'text',
                            value: challenge_state.new_exercise.short_description,
                            onchange: _dom => {
                                challenge_state.new_exercise.short_description = _dom.target.value
                            }
                        })
                    ])
                ]),


                m('.line', [
                    m('.line-element', [
                        m(GroupsSelector)
                    ]),
                    m('.line-element', [
                        m(SportsSelector)
                    ])
                ]),

                has_permission('exercises.canCreatePublic') &&
                [
                    m('.line.line--with-explainer', [
                        m('.line-element', [
                            m('label', [
                                trans('exercises.form.visibility'),
                            ]),
                            m('select', {
                                value: this.get_visibility(),
                                onchange: e => this.set_visibility(e.target.value*1)
                            }, [
                                has_permission('exercises.canCreatePublic') &&
                                m('option', {
                                    value: 0
                                }, trans('common.public')),

                                m('option', {
                                    value: 1
                                }, trans('common.private')),

                                has_permission('exercises.canCreatePublic') &&
                                m('option', {
                                    value: 2
                                }, trans('common.unlisted'))
                            ])
                        ])
                    ]),
                    m('.line__explainer',
                        trans('exercises.visibility.' + this.get_visibility() + '.explainer')
                    ),
                ],

                challenge_state.exercise_loading &&
                m('.general-loader', ''),

                !challenge_state.exercise_loading &&
                m('.line.line--center', [
                    m('.btn.btn--full-width.btn--main#submit_form', {
                        onclick: e => this.save_exercise(e) 
                    }, trans('challenge.continue_btn'))
                ]),
            ])
        ]
    }
}

export default CreateExercise;